/**
 * FormControlLabel component overrides.
 * Clean labels with body2 typography.
 */

import type { Theme } from '@mui/material/styles';

const formControlLabel: Theme['components'] = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          opacity: 0.45,
        },
      },
      label: ({ theme }) => ({
        ...theme.typography.body2,
        color: 'var(--mui-palette-text-primary)',
      }),
    },
  },
};

export default formControlLabel;
